var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarJoinUsArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2736 6.54055L7.10557 0.319235C7.05055 0.271802 6.98034 0.245239 6.90635 0.245239H5.22722C5.08682 0.245239 5.02231 0.419793 5.12856 0.510864L11.773 6.27872H0.669852C0.58637 6.27872 0.518066 6.34702 0.518066 6.43051V7.5689C0.518066 7.65238 0.58637 7.72069 0.669852 7.72069H11.7711L5.12666 13.4885C5.02041 13.5815 5.08492 13.7542 5.22532 13.7542H6.96137C6.99742 13.7542 7.03347 13.7409 7.06003 13.7162L14.2736 7.45886C14.3393 7.40174 14.392 7.33119 14.4281 7.25199C14.4642 7.17278 14.4828 7.08675 14.4828 6.9997C14.4828 6.91266 14.4642 6.82663 14.4281 6.74742C14.392 6.66821 14.3393 6.59767 14.2736 6.54055Z",
    fill: "url(#paint0_linear_1917_679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1917_679",
    x1: 7.53861,
    y1: 13.8276,
    x2: 7.53861,
    y2: 0.245238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2054E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C62FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarJoinUsArrow);
export default __webpack_public_path__ + "static/media/sidebar-join-us-arrow.f0f5fb9d2f162b0ea4083a668a0eb0c3.svg";
export { ForwardRef as ReactComponent };